export default __webpack_public_path__ + "static/media/ded-tools-ms-365.293a29b9.svg";